import type { HeadingProps } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import React from "react";

export const H2B = (props: HeadingProps) => (
  <Heading
    as="h2"
    fontSize={{ base: "lg", sm: "xl", md: "2xl", lg: "35px  " }}
    {...props}
  />
);
